import axios from 'axios'
import { Toast } from 'vant'
import qs from 'qs'
import storage from '@/utils/storage'

// 设置token
const token = storage.getToken() || ''
// const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MjYyOTc5NTAsImp0aSI6IjcwNTIyMjMyMjA2MDIxMDk5NTIifQ.VzFqaonbSQpC4rYVzWgD8tKOho5McmxY6l9-UajZtBs'
if (token) axios.defaults.headers.common.Authorization = `Bearer ${token}`

// 请求拦截器
axios.interceptors.request.use(function(config) {
    if (config.method === 'post' || config.method === 'put') {
        // config.data = qs.stringify(config.data) // formData
        config.data = qs.parse(config.data) // 对象(json)
    }
    return config
}, function(error) {
    return Promise.reject(error)
})

// 响应拦截器
axios.interceptors.response.use(function(response) {
    if (response.data.code !== 0) {
        Toast(response.data.msg)
        return Promise.reject(new Error(response.data.msg))
    } else {
        return Promise.resolve(response.data)
    }
}, function(error) {
    console.log('请求异常响应拦截', error)
    const status = parseInt(error.response.status)
    if (status === 500) {
        Toast(error.response.data.msg)
    }

    // Toast('请求服务器错误')
    return Promise.reject(error)
})

const http = (method, url, params) => {
    return new Promise((resolve, reject) => {
        axios({
            method: method,
            url: url,
            data: method !== 'get' || method !== 'GET' ? params : undefined, // 不等于get
            params: method === 'get' || method === 'GET' ? params : undefined // get
        }).then((res) => {
            resolve(res)
        }).catch((err) => {
            reject(err)
        })
    })
}

export default http
